import { render, staticRenderFns } from "./criteria-form-drawer.vue?vue&type=template&id=0f64d6c2"
import script from "./criteria-form-drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./criteria-form-drawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./criteria-form-drawer.vue?vue&type=style&index=0&id=0f64d6c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports